var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrialSynchronizeArrows = function SvgTrialSynchronizeArrows(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42578 20.6799L6.99978 28.9799L13.4098 21.3039",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97805 28.878C5.90314 24.2968 6.67606 19.4765 9.12944 15.4611C11.5828 11.4456 15.5192 8.55816 20.0861 7.42399C23.0795 6.71384 26.2096 6.83013 29.1421 7.76043C32.0747 8.69073 34.6994 10.4001 36.7361 12.706",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5699 27.284L40.9959 18.98L34.5859 26.656",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0178 19.0862C42.0921 23.6674 41.319 28.4874 38.8657 32.5027C36.4124 36.518 32.4764 39.4055 27.9098 40.5402C24.9163 41.2486 21.7866 41.1314 18.8545 40.2012C15.9223 39.271 13.2975 37.5626 11.2598 35.2582",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.9819C26.2091 27.9819 28 26.1911 28 23.9819C28 21.7728 26.2091 19.9819 24 19.9819C21.7909 19.9819 20 21.7728 20 23.9819C20 26.1911 21.7909 27.9819 24 27.9819Z",
    fill: "#0258FF",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrialSynchronizeArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trial-synchronize-arrows.7a8728d7.svg";
export { ForwardRef as ReactComponent };